export const GET_FOLDERS_URL = "https://api.gisp.org.uk/getfolders";
export const GET_DOCUMENTS_URL = "https://api.gisp.org.uk/getdocuments";
export const GET_LATEST_DOCUMENTS_LIMIT = 5;
